import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";

/**
 * Rendu en lecture seule d'un contenu de chapitre au format Markdown,
 * avec support des tableaux/listes (GFM) et des formules mathématiques
 * LaTeX (remark-math + KaTeX). Utilisé partout où le contenu d'un
 * chapitre est affiché à l'étudiant.
 */
export default function MarkdownContent({ content, className = "" }) {
  if (!content) return null;
  return (
    <div className={`prose prose-slate max-w-none prose-headings:font-display prose-img:rounded-lg prose-a:text-primary ${className}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkMath]} rehypePlugins={[rehypeKatex]}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
